// extracted by mini-css-extract-plugin
export default {"adult":"adultcontent_adult__0vIAS"};